import { detectVideoService } from './videoServiceDetector';

/**
 * Check if all videos in a gallery are from the same service
 * @param {Array} videos - Array of video objects
 * @param {string} serviceName - Service to check for ('youtube', 'vimeo', 'dailymotion')
 * @returns {boolean} - True if all videos are from the specified service
 */
export const areAllVideosFromService = (videos, serviceName) => {
  if (!videos || videos.length === 0) return false;

  return videos.every(video => {
    const service = detectVideoService(video.url);
    return service === serviceName;
  });
};

/**
 * Check if all videos in a gallery are YouTube videos
 * @param {Array} videos - Array of video objects
 * @returns {boolean} - True if all videos are YouTube
 */
export const areAllVideosYouTube = (videos) => {
  return areAllVideosFromService(videos, 'youtube');
};
